import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-gray-200 last:border-0" data-id="element-11">
      <button className="w-full py-4 px-6 flex items-center justify-between text-left focus:outline-none hover:bg-gray-50 transition-colors" onClick={onClick} data-id="element-12">
        <span className="text-lg font-semibold text-gray-900" data-id="element-13">{question}</span>
        {isOpen ? <ChevronUpIcon className="w-5 h-5 text-blue-600" data-id="element-14" /> : <ChevronDownIcon className="w-5 h-5 text-gray-400" data-id="element-15" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-16">
        <div className="p-6 pt-0 text-gray-600 leading-relaxed" data-id="element-17">{answer}</div>
      </div>
    </div>;
}
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Es una dieta restrictiva?',
    answer: 'No. Es un sistema estructurado que crea déficit sin extremos.'
  }, {
    question: '¿Necesito ir al gimnasio?',
    answer: 'No. Incluye rutinas en casa de 20 minutos.'
  }, {
    question: '¿Funciona si trabajo muchas horas?',
    answer: 'Sí. Está diseñado para personas ocupadas.'
  }, {
    question: '¿Cuánto peso puedo perder?',
    answer: 'Muchas personas pierden hasta 4–5 kg en 30 días, dependiendo de su punto inicial y compromiso.'
  }, {
    question: '¿Es digital?',
    answer: 'Sí. Acceso inmediato tras la compra.'
  }];
  return <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden max-w-3xl mx-auto" data-id="element-18">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-19" />)}
    </div>;
}